import React, { useState } from "react";
import BottomNav from "../../../Components/BottomNav";
import NavBar from "../../../Components/interface/NavBar";
import styles from "./Services.module.css";
import WorkShopList from "./WorkShopList";
import EmailInput from "../../../Components/inputs/EmailInput";

function Services(props) {
  const [searchInput, setSearchInput] = useState("");
  const [result, setResult] = useState(false);
  const searchInputChangeHandler = (e) => {
    setSearchInput(e.target.value);
  };
  const formSubmitHandler = (e) => {
    e.preventDefault();
    console.log(searchInput);
    setResult(true);
    setSearchInput("");
  };
  return (
    <section>
      <NavBar title="Services" setShowMenu={props.setShowMenu} />
      <div className={styles.head}>
        <div className={styles.main_hero}>
          {/* <InsuranceMenu
            first="Services"
            first_link="services"
            second="Spare Parts"
            second_link="spare-parts"
          /> */}
          <form onSubmit={formSubmitHandler}>
            <div>
              <EmailInput
                value={searchInput}
                onChange={searchInputChangeHandler}
                name="search"
                placeholder="Search for"
              />
            </div>
          </form>
          <WorkShopList
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            result={result}
          />
        </div>
      </div>

      <BottomNav />
    </section>
  );
}

export default Services;
